import { useMemo } from 'react';

import { useGetCustomerCreditQuery } from './GraphQL/Credit.generated';

/**
 * Some information on credit use throughout the app.
 * availableCredit: Amount of credit that is available.
 * checkoutCredit: Amount of credit applied to checkout.
 * useCredit: Whether or not credit should apply to checkout.
 * credits: Itemized list of operations that form the total credit amount.
 */

export const useCustomerCredit = () => {
  const [response, refetchCredits] = useGetCustomerCreditQuery({
    requestPolicy: 'network-only',
  });
  const customer = response?.data?.currentCustomer;
  const isLoadingCredits = response.fetching || response.stale;

  return useMemo(
    () => ({
      availableCredit: customer?.availableCredit ?? 0,
      useCredit: customer?.useCredit ?? false,
      credits: customer?.credits ?? [],
      isLoadingCredits,
      refetchCredits,
    }),
    [
      customer?.availableCredit,
      customer?.useCredit,
      customer?.credits,
      isLoadingCredits,
      refetchCredits,
    ],
  );
};
